import {login} from "../../api/login";

export const user = {
  state: {
    userInfo: null, // 用户信息
  },
  mutations: {
    SET_USERINFO: (state, userInfo) => {
      if (userInfo) {
        state.userInfo = userInfo;
      } else {
        state.userInfo = {}
      }
    },
    loginOut: (state) => {
      localStorage.removeItem('userInfo');
      state.userInfo = {}
    }
  },
  actions: {
    systemLogin ({commit},params) {
      return new Promise((resolve) => {
        login(params).then(res => {
          localStorage.setItem('userInfo', JSON.stringify(res.data))
          commit('SET_USERINFO', res);
          resolve()
        })
      })
    },
    systemLoginOut ({commit}) {
      return new Promise((resolve) => {
        commit('loginOut')
        resolve()
      })
    }
  }
}
